import React from 'react';
import { useSelector } from 'react-redux';
import NotFound from '../../../pages/404';
import { useParams } from 'react-router-dom';

const SecureRouteForAuthorizeStudentAndInstructor = ({ children }) => {
    const { user } = useSelector((state) => state.profile);
    const { courseId } = useParams();
    for (const enrolledCourse of user.courses) {
        if (enrolledCourse === courseId) {
            return children;
        }
    }
    return <NotFound />;
}

export default SecureRouteForAuthorizeStudentAndInstructor;